import { render, staticRenderFns } from "./SelectDicName.vue?vue&type=template&id=3ca9b851&scoped=true"
import script from "./SelectDicName.vue?vue&type=script&lang=js"
export * from "./SelectDicName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca9b851",
  null
  
)

export default component.exports